export var getIsMixedClassByProps = function (props) {
    var cabinClassNames = props.cabinClassNames;
    return !cabinClassNames.every(function (c) { return c === cabinClassNames[0]; });
};
//# sourceMappingURL=utils.js.map